module.exports = __webpack_public_path__ + "img/end-of-day.bd78dfbb.png";